export const CHAT_GPT_REQ = {
  temperature: 1.5,
  max_tokens: 500,
  model: 'gpt-3.5-turbo',
};
